import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import API_URL from '../config';
import { SovrynnLogo } from '../components/Brand';
import PublicLegalFooter from '../components/legal/PublicLegalFooter';
import { CheckCircle2 } from 'lucide-react';
import '../App.css';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [emailFocused, setEmailFocused] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [submittedEmail, setSubmittedEmail] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post(`${API_URL}/api/auth/forgot-password`, { email: email.trim() });
    } catch (err) {
      setError(
        err.response?.data?.message ||
          'Something went wrong. Please try again or check your connection.',
      );
      setLoading(false);
      return;
    }
    setSubmittedEmail(email.trim());
    setSuccess(true);
    setLoading(false);
  };

  if (success) {
    return (
      <div className="login-container-wrapper">
        <div className="login-container">
          <div className="login-content">
            <div className="auth-logo">
              <SovrynnLogo size="lg" />
            </div>
            <CheckCircle2 className="auth-success-icon" size={56} strokeWidth={2} aria-hidden />
            <h1 className="auth-page-title">Check your email</h1>
            <p className="auth-page-subtitle">
              If an account exists for {submittedEmail}, you&apos;ll receive a reset link shortly. Check your spam folder
              if you don&apos;t see it.
            </p>
            <Link to="/login" className="auth-back-link">
              &larr; Back to Sign In
            </Link>
          </div>
        </div>
        <PublicLegalFooter />
      </div>
    );
  }

  return (
    <div className="login-container-wrapper">
      <div className="login-container">
        <div className="login-content">
          <div className="auth-logo">
            <SovrynnLogo size="lg" />
          </div>
          <h1 className="auth-page-title">Reset your password</h1>
          <p className="auth-page-subtitle">Enter your email address and we&apos;ll send you a reset link.</p>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="input-group">
              <label
                htmlFor="forgot-email"
                className={`form-label ${emailFocused || email ? 'focused' : ''}`}
              >
                Email
              </label>
              <input
                id="forgot-email"
                type="email"
                className="form-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onFocus={() => setEmailFocused(true)}
                onBlur={() => setEmailFocused(email.length > 0)}
                placeholder="you@example.com"
                required
                autoComplete="email"
              />
            </div>

            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>

            {error ? <p className="auth-inline-error">{error}</p> : null}

            <div className="register-link" style={{ marginTop: 20 }}>
              <Link to="/login" className="register-link-text">
                &larr; Back to Sign In
              </Link>
            </div>
          </form>
        </div>
      </div>
      <PublicLegalFooter />
    </div>
  );
}
